var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53519 0.664062C5.78787 0.664062 5.18626 1.35142 5.18626 2.20516V4.85248H1.38886C0.803913 4.85248 0.333008 5.32337 0.333008 5.9083V16.4872C0.333008 17.0721 0.803913 17.543 1.38886 17.543H16.9353C17.5202 17.543 17.9911 17.0721 17.9911 16.4872V16.3193C16.7071 16.17 15.5225 15.5546 14.662 14.5899C13.8016 13.6251 13.3252 12.3781 13.3232 11.0854C13.3251 9.79367 13.8008 8.5475 14.66 7.58298C15.5193 6.61845 16.7025 6.00256 17.9854 5.85199C17.9558 5.29399 17.5009 4.85248 16.9353 4.85248H13.2911V2.20516C13.2911 1.35142 12.6895 0.664062 11.9421 0.664062H6.53519ZM6.70019 2.44969H11.711V4.85248H6.70019V2.44969ZM22.4326 3.64795C21.6311 3.64795 20.9859 4.29322 20.9859 5.09472V9.44116L16.6395 9.45969C15.838 9.46305 15.1955 10.1111 15.1989 10.9125C15.2023 11.714 15.8504 12.3566 16.6519 12.3532L20.9859 12.3347V16.6687C20.9859 17.4703 21.6311 18.1156 22.4326 18.1156C23.2341 18.1156 23.8794 17.4703 23.8794 16.6687V12.3224L28.2258 12.3038C29.0273 12.3005 29.6697 11.6525 29.6663 10.851C29.6629 10.0495 29.015 9.40695 28.2135 9.41037L23.8794 9.42881V5.09472C23.8794 4.29322 23.2341 3.64795 22.4326 3.64795Z",
    fill: "#467BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCase);
export default __webpack_public_path__ + "static/media/add-to-case.5b42cd0c24d8892e019d23619a3cbccb.svg";
export { ForwardRef as ReactComponent };